import Person from "./Person.mjs";
import RelationshipType from "./RelationshipType.mjs";
export default class Self extends Person {
    static create(name, gender) {
        this.resetLastUsedUuid();
        this.self = new Self(name, gender);
        return this.self;
    }
    static get() {
        if (!this.self) {
            throw new Error("Self must be created before it can be retrieved");
        }
        return this.self;
    }
    constructor(name, gender) {
        super(name, RelationshipType.SELF, gender, /* alive= */ false);
        this._spouses = [];
        this._allInheritors = [];
        this._allInheritorsExcludingSpouses = [];
        // These are set within calculate#calculateInheritance
        this._livingGrandSons = [];
        this._livingGrandDaughters = [];
        // In order to calculate radd, we need to keep track of the ratios for all groups of people that have been calculated
        // I.e. if there are 3 daughters, 2/3 is split between them, so each get 2/9.
        this._distributedRatios = [];
        this.hasLivingSon = false;
        this.hasLivingDaughter = false;
        this.hasLivingMaleDescendent = false;
        this.hasLivingFemaleDescendent = false;
        this.hasLivingFullBrother = false;
        this.hasLivingFullSister = false;
        this.addedInheritorsUuid = new Set();
    }
    addMother(mother) {
        super.addMother(mother);
        this.addInheritor(mother);
    }
    addFather(father) {
        super.addFather(father);
        this.addInheritor(father);
    }
    addSon(son) {
        super.addSon(son);
        if (son.alive) {
            this.hasLivingSon = true;
        }
        this.addInheritor(son);
    }
    addBrother(brother) {
        super.addBrother(brother);
        if (brother.alive) {
            this.hasLivingFullBrother = true;
        }
        this.addSibling(brother);
    }
    addSister(sister) {
        super.addSister(sister);
        if (sister.alive) {
            this.hasLivingFullSister = true;
        }
        this.addSibling(sister);
    }
    addDaughter(daughter) {
        super.addDaughter(daughter);
        if (daughter.alive) {
            this.hasLivingDaughter = true;
        }
        this.addInheritor(daughter);
    }
    addSpouse(spouse) {
        super.addSpouse(spouse);
        this.addInheritor(spouse, true);
    }
    hasLivingPaternalAncestors() {
        var _a, _b;
        return !!(((_a = this._father) === null || _a === void 0 ? void 0 : _a.alive) || ((_b = this.getPaternalGrandFather()) === null || _b === void 0 ? void 0 : _b.alive));
    }
    getPaternalGrandFather() {
        var _a;
        return (_a = this._father) === null || _a === void 0 ? void 0 : _a._father;
    }
    getPaternalGrandMother() {
        var _a;
        return (_a = this._father) === null || _a === void 0 ? void 0 : _a._mother;
    }
    getMaternalGrandFather() {
        var _a;
        return (_a = this._mother) === null || _a === void 0 ? void 0 : _a._father;
    }
    getMaternalGrandMother() {
        var _a;
        return (_a = this._mother) === null || _a === void 0 ? void 0 : _a._mother;
    }
    addInheritor(inheritor, isSpouse = false) {
        if (this.addedInheritorsUuid.has(inheritor.uuid)) {
            return;
        }
        this.addedInheritorsUuid.add(inheritor.uuid);
        this._allInheritors.push(inheritor);
        if (!isSpouse) {
            this._allInheritorsExcludingSpouses.push(inheritor);
        }
    }
    addSibling(sibling) {
        if (!sibling._mother && !sibling._father) {
            throw new Error("Sibling must have at least one parent defined");
        }
        this.addInheritor(sibling);
    }
    addNonImmediateRelative(relative) {
        this.addInheritor(relative);
    }
}
